import { useAbTestComponent, loadLazyComponent } from "@hook";
import { inject, observer } from "mobx-react";

import Default from "./Default";

const abTests = {
    "dev_1171_12.11.2025__v2": loadLazyComponent(() => import("./AB_1171")), //15/01/26 еще не запущен
    "DEV-2389__v2": loadLazyComponent(() => import("./AB_2389")), // не запущен
};

const ListItem = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default ListItem;
